/**
 * Tiny dependency-free className composer. Filters out falsy values
 * (`false`/`null`/`undefined`/`""`) so conditional classes read cleanly:
 *
 *   cn("base", isActive && "active", className)
 *
 * Intentionally NOT tailwind-merge — this project resolves Tailwind class
 * conflicts by hand (as it always has). Adopt incrementally in files we touch;
 * don't churn untouched files just to swap `.join(" ")` for `cn`.
 */
export function cn(
  ...parts: Array<string | false | null | undefined>
): string {
  return parts.filter(Boolean).join(" ");
}
